import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getNavigationStats } from '../../../api/stats';

const useNavigationStats = (
  params?: { organizationId?: string; systemId?: string },
  queryOptions?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['getNavigationStats', params],
    queryFn: () => getNavigationStats(params?.organizationId, params?.systemId),
    ...queryOptions,
  });
};

export default useNavigationStats;
